import { api } from "./config";

export async function GetAllRoutes() {
  try {
    const response = await api().get("/route/all");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function StoreRoute(data) {
  try {
    const response = await api().post("/route/store", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function PatchRoute(data) {
  try {
    const response = await api().patch("/route/patch", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function DeleteRoute(id) {
  try {
    const response = await api().delete(`/route/delete/${id}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetRouteList() {
  try {
    const response = await api().get("/route/list");
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.error(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetRouteListByStation(stationId) {
  try {
    const response = await api().get("/route/list-by-station", {
      // Backend reads `stationId` (matches the mobile client). Sending `id`
      // here silently matched nothing → the route filter always returned [].
      params: {
        stationId: stationId,
      },
    });
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.error(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetRouteDetail(routeId) {
  try {
    const response = await api().get("/route/detail", {
      params: {
        id: routeId,
      },
    });
    
    // Handle standardized response format
    if (response.status === 200 && response.data.success) {
      return {
        status: 200,
        data: response.data.data
      };
    } else if (response.status === 404 || !response.data.success) {
      return {
        status: 404,
        message: response.data.message || "Route not found"
      };
    }
    
    return response.data;
  } catch (error) {
    console.error(error);
    
    // Handle error responses
    if (error.response?.status === 404) {
      return {
        status: 404,
        message: error.response.data?.message || "Route not found"
      };
    } else if (error.response?.status === 400) {
      return {
        status: 400,
        message: error.response.data?.message || "Invalid route ID"
      };
    }
    
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetRouteByProvince(pr_id) {
  try {
    const response = await api().get(
      "/location/get-route-by-province",
      {
        params: {
          id: pr_id,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
